module.exports = "<section id=\"action\">\n    <div class=\"row\">\n        <div class=\"col-sm-12\">\n            <div class=\"card radius-wrapper-card\">\n                <div class=\"card-header\">\n                    <h4 class=\"card-title\">{{ 'Invoice List' | translate }}</h4>\n                </div>\n                <app-invoices-list [isAdmin]=\"false\"></app-invoices-list>\n            </div>\n        </div>\n    </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/client/invoices/invoices/invoices.component.html
// module id = ../../../../../app/src/app/client/invoices/invoices/invoices.component.html
// module chunks = invoices.module.0